module.exports = __webpack_public_path__ + "static/media/opensans-regular.1a741cff.woff2";